import {create} from 'zustand';

const useStore = create((set) => ({
    totalInfo: {}, // Initialize with an empty object or any default value
    setTotalInfo: (newInfo) => set({ totalInfo: newInfo }), 
    setCourseName:(courseName)=>set({Name:courseName}),
    setCourseId:(courseId)=>set({Id:courseId})
    
  }));
  

export default useStore;
